module.exports = require('./helpers/bundle-url').getBundleURL('bm7gR') + "logo.c51670a8.svg";